import React, { useState } from 'react';
import { Button, Container, Image } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { AppConstants } from 'constant/index.js';
import VolunteeringVolunteerLearningScreens from './index.js';
import Layout from 'components/layout.js';
import Page404Screen from 'screens/404';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Modal } from 'components/index.js';
import { volunteerWhite } from 'assets/icons/index.js';

const { PATH_VOLUNTEERING_LEARNING_VOLUNTEER } = AppConstants;

const EngageLearningScreen = () => {
  const { t } = useTranslation();
  
  const params = new URLSearchParams(window.location.search);
  const page = Number.parseInt(params.get('page') ?? 1);
  const element = VolunteeringVolunteerLearningScreens['page' + page];

  const [showContent, setShowContent] = useState(false);

  if (!element) {
    return <Page404Screen />;
  }
  return (
    <Layout>
      {page !== 1 &&
        (
          <div className='volunteering-background pt-3 pb-3'>
            <div className='d-flex flex-direction-row align-items-center justify-content-center'>
              <Image src={volunteerWhite} width={24} height={24} className="text-white" />
              <h4 className='pl-2 pb-0 mb-0 text-white'>{t('learning.volunteering.volunteer.header.1')}</h4>
            </div>
            <p className='pb-0 mb-0 text-white text-center'>{t('learning.volunteering.volunteer.header.2')}</p>
          </div>
        )}
      <ContentModal visible={showContent} onHide={() => setShowContent(false)} />
      <div className='d-flex flex-direction-column justify-content-between p-5 pt-0' style={{ minHeight: '100%' }}>
        <Container className='page'>
          {element}
        </Container>
        <div className='page d-flex flex-direction-row align-items-center justify-content-center mb-5'>
          <Button variant='outline-volunteering' disabled={page === 1} style={{ opacity: (page === 1) ? 0 : 1 }} onClick={() => window.location.href = PATH_VOLUNTEERING_LEARNING_VOLUNTEER + '?page=' + (page - 1)}>
            <div className='d-flex flex-direction-row align-items-center'>
              <FontAwesomeIcon icon={'arrow-left'} className='text-volunteering' />
              <span>&nbsp;{t('previous')}</span>
            </div>
          </Button>
          <div className='px-5'>
            <p className='text-volunteering pt-4 pb-0 mb-0 text-center'>{page} / {Object.keys(VolunteeringVolunteerLearningScreens).length}</p>
            <Button variant='link' className='text-volunteering pt-0 mt-0' onClick={() => setShowContent(true)}>
              <p className='text-center'><small>{t('content')}</small></p>
            </Button>
          </div>
          <Button variant='outline-volunteering' disabled={page === Object.keys(VolunteeringVolunteerLearningScreens).length} style={{ opacity: (page === Object.keys(VolunteeringVolunteerLearningScreens).length) ? 0 : 1 }} onClick={() => window.location.href = PATH_VOLUNTEERING_LEARNING_VOLUNTEER + '?page=' + (page + 1)}>
            <div className='d-flex flex-direction-row align-items-center'>
              <span>{t('next')}&nbsp;</span>
              <FontAwesomeIcon icon={'arrow-right'} className='text-volunteering' />
            </div>
          </Button>
        </div>
      </div>
    </Layout>
  )
}

const ContentModal = ({ visible, onHide }) => {
  const { t } = useTranslation();

  return (
    <Modal show={visible} onHide={onHide} className={'p-0'}>
      <h4 className={'px-4'}>{t('learning.volunteering.volunteer.menu.1')}</h4>
      <ul style={{ listStyle: 'none' }} className='px-4'>
        <li><a className='text-volunteering' href={PATH_VOLUNTEERING_LEARNING_VOLUNTEER + '?page=2'}>{t('learning.volunteering.volunteer.menu.2')}</a></li>
        <ul style={{ listStyle: 'none' }}>
          <li><a className='text-volunteering' href={PATH_VOLUNTEERING_LEARNING_VOLUNTEER + '?page=3'}>{t('learning.volunteering.volunteer.menu.3')}</a></li>
          <li><a className='text-volunteering' href={PATH_VOLUNTEERING_LEARNING_VOLUNTEER + '?page=4'}>{t('learning.volunteering.volunteer.menu.4')}</a></li>
          <li><a className='text-volunteering' href={PATH_VOLUNTEERING_LEARNING_VOLUNTEER + '?page=5'}>{t('learning.volunteering.volunteer.menu.5')}</a></li>
        </ul>
        <li><a className='text-volunteering' href={PATH_VOLUNTEERING_LEARNING_VOLUNTEER + '?page=6'}>{t('learning.volunteering.volunteer.menu.7')}</a></li>
        <ul style={{ listStyle: 'none' }}>
          <li><a className='text-volunteering' href={PATH_VOLUNTEERING_LEARNING_VOLUNTEER + '?page=6'}>{t('learning.volunteering.volunteer.menu.8')}</a></li>
          <li><a className='text-volunteering' href={PATH_VOLUNTEERING_LEARNING_VOLUNTEER + '?page=6'}>{t('learning.volunteering.volunteer.menu.9')}</a></li>
          <li><a className='text-volunteering' href={PATH_VOLUNTEERING_LEARNING_VOLUNTEER + '?page=7'}>{t('learning.volunteering.volunteer.menu.10')}</a></li>
          <li><a className='text-volunteering' href={PATH_VOLUNTEERING_LEARNING_VOLUNTEER + '?page=7'}>{t('learning.volunteering.volunteer.menu.11')}</a></li>
        </ul>
        <li><a className='text-volunteering' href={PATH_VOLUNTEERING_LEARNING_VOLUNTEER + '?page=8'}>{t('learning.volunteering.volunteer.menu.12')}</a></li>
        <ul style={{ listStyle: 'none' }}>
          <li><a className='text-volunteering' href={PATH_VOLUNTEERING_LEARNING_VOLUNTEER + '?page=9'}>{t('learning.volunteering.volunteer.menu.13')}</a></li>
          <li><a className='text-volunteering' href={PATH_VOLUNTEERING_LEARNING_VOLUNTEER + '?page=9'}>{t('learning.volunteering.volunteer.menu.14')}</a></li>
        </ul>
        <li><a className='text-volunteering' href={PATH_VOLUNTEERING_LEARNING_VOLUNTEER + '?page=10'}>{t('learning.volunteering.volunteer.menu.15')}</a></li>
        <li><a className='text-volunteering' href={PATH_VOLUNTEERING_LEARNING_VOLUNTEER + '?page=11'}>{t('learning.volunteering.volunteer.menu.16')}</a></li>
        <ul style={{ listStyle: 'none' }}>
          <li><a className='text-volunteering' href={PATH_VOLUNTEERING_LEARNING_VOLUNTEER + '?page=11'}>{t('learning.volunteering.volunteer.menu.17')}</a></li>
          <li><a className='text-volunteering' href={PATH_VOLUNTEERING_LEARNING_VOLUNTEER + '?page=11'}>{t('learning.volunteering.volunteer.menu.18')}</a></li>
          <li><a className='text-volunteering' href={PATH_VOLUNTEERING_LEARNING_VOLUNTEER + '?page=12'}>{t('learning.volunteering.volunteer.menu.19')}</a></li>
          <li><a className='text-volunteering' href={PATH_VOLUNTEERING_LEARNING_VOLUNTEER + '?page=13'}>{t('learning.volunteering.volunteer.menu.20')}</a></li>
          <li><a className='text-volunteering' href={PATH_VOLUNTEERING_LEARNING_VOLUNTEER + '?page=14'}>{t('learning.volunteering.volunteer.menu.21')}</a></li>
          <li><a className='text-volunteering' href={PATH_VOLUNTEERING_LEARNING_VOLUNTEER + '?page=15'}>{t('learning.volunteering.volunteer.menu.22')}</a></li>
          <li><a className='text-volunteering' href={PATH_VOLUNTEERING_LEARNING_VOLUNTEER + '?page=16'}>{t('learning.volunteering.volunteer.menu.23')}</a></li>
        </ul>
        <li><a className='text-volunteering' href={PATH_VOLUNTEERING_LEARNING_VOLUNTEER + '?page=17'}>{t('learning.volunteering.volunteer.menu.24')}</a></li>
        <li><a className='text-volunteering' href={PATH_VOLUNTEERING_LEARNING_VOLUNTEER + '?page=18'}>{t('learning.volunteering.volunteer.menu.25')}</a></li>
      </ul>
    </Modal>
  )
}

export default EngageLearningScreen;